export const COURSE_FILE_MAX_SIZE = 500e6; // 500MB

export const COURSE_THUMBNAIL_MAX_SIZE = 2e6; // 2MB

export const COURSE_THUMBNAIL_ACCEPTED_FORMATS = [
  '.png',
  '.jpg',
  '.jpeg',
  '.svg',
  '.gif',
];

export const CONTENT_IMAGE_ACCEPTED_FORMATS = ['.png', '.jpg', '.jpeg', '.gif'];
export const CONTENT_VIDEO_ACCEPTED_FORMATS = ['.mp4'];
export const CONTENT_GIF_MAX_SIZE = 15e6; // 15MB
export const CONTENT_VIDEO_MAX_SIZE = COURSE_FILE_MAX_SIZE;
export const QUIZ_IMAGE_ACCEPTED_FORMATS = [
  '.png',
  '.jpg',
  '.jpeg',
  '.gif',
  '.mp4',
];
